module.exports = __webpack_public_path__ + "media/images/customer-avatar-icon-7c52817430d1a1d6325af8f68de3c6cc.png";